import { Accordion } from '@risksmart-app/atomic-ui';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ScheduleDetailsFields } from './ScheduleDetailsFields';
import { ScheduleRecurrenceFields } from './ScheduleRecurrenceFields';

const sectionIds = ['details', 'schedule'];

const ScheduleForm: FC = () => {
  const { t } = useTranslation(['common'], {
    keyPrefix: 'scheduler.sections',
  });

  return (
    <Accordion multiple={true} defaultValue={sectionIds}>
      <Accordion.Item value={'details'}>
        <Accordion.Header>
          <Accordion.Trigger>{t('details')}</Accordion.Trigger>
        </Accordion.Header>
        <Accordion.Content>
          <ScheduleDetailsFields />
        </Accordion.Content>
      </Accordion.Item>
      <Accordion.Item value={'schedule'}>
        <Accordion.Header>
          <Accordion.Trigger>{t('schedule')}</Accordion.Trigger>
        </Accordion.Header>
        <Accordion.Content>
          <ScheduleRecurrenceFields />
        </Accordion.Content>
      </Accordion.Item>
    </Accordion>
  );
};

export default ScheduleForm;
